import styled from "styled-components";
import React, { useState } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { LoadingWLogo } from "../../components/LoadingWLogo";
import { PodCredit } from "../../assets/Podcast/PodCredit";
import { TextBtn } from "../../components/inputs/TextBtn";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { TextInputWTitle } from "../../components/inputs/TextInputWTitle";
import { formatPrice } from "../../components/helper/Price";
import { SelectInputWTitle } from "../../components/inputs/SelectInputWTitle";

const StyleCss = styled.div`
  .campaign {
    margin: 7.5px;
    padding: 5px 10px;
    border: 1px solid var(--n-grey-3);
    background-color: var(--n-grey-1);
    border-radius: 8px;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-decoration: none;
    color: var(--n-text-2);
    transition: all 0.15s ease-in-out;
    :hover {
      border: 1px solid var(--n-grey-7);
      color: var(--n-text-1);
    }
    &.header {
      border: none;
      background-color: transparent;
      margin: 7.5px 7.5px 0;
      font-weight: 500;
      .column {
        padding: 0.5rem 0.5rem 0;

      }
    }
    .column {
      padding: 0.5rem;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    .row {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      .title {
        font-size: 1.1rem;
        font-weight: 500;
        min-width: 200px;
      }
      .input {
        align-items: center;
        display: flex;
        gap: 0.3rem;
      }
      .text {
        white-space: nowrap;
      }
    }
    .full-width {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(12, calc(calc(100% / 12) - calc(110px / 12)));
      grid-gap: 10px;
      margin: 2rem 0 0;
      padding: 2rem 0 0;
      border-top: 1px solid var(--n-grey-3);
    }
  }
`;

const AddOrEditCredit_Mutation = gql`
  mutation AddOrEditCredit(
    $_id: ID, 
    $type: String!, 
    $amount: Int!, 
    $installment: Int!
  ){
    addOrEditCredit(
      _id: $_id
      type: $type
      amount: $amount
      installment: $installment
    ){
        status
    }
  }
`

function WorkPageCreditEdit(props) {
  const history = useHistory();
  const [shop, setShop] = useState("LuxinLux")
  const [amount, setAmount] = useState("")
  const [installment, setInstallment] = useState(1)
  const [CDataQuery, { loading }] = useMutation(
    AddOrEditCredit_Mutation,
    {
      onCompleted: proccessData,
    }
  );
  function proccessData(newData) {
    if (newData.addOrEditCredit.status) {
      props.updateError({
          text: 'Saved successfully',
          time: 3,
          type: 'confirm'
      });
      history.push("/work/credit");
    }
  }
  const selectShop = (e) => {
   setShop(e.target.innerText)
  }
  const onchange = (e) => {
    let value = e.target.value;
    switch (e.target.name) {
      case "amount":
        if(value === ""){
          setAmount("");
        }
        if(!isNaN(parseInt(value))){
          setAmount(parseInt(value));
        }
        break;
      case "installment":
        setInstallment(value);
        break;
      default:
        break;
    }
  };
  const cancel = () => {
    history.push("/work/credit");
  };
  const checkData = () => {
    if (
      amount
    ) {
      return true;
    } else {
      return false;
    }
  };
  function sendData() {
    // setChanged(false);
    CDataQuery({
      variables: {
        amount: amount,
        installment: parseInt(installment),
        type: shop,
      },
    });
  }
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodCredit/></div>
            <div className="text">Shopping Credit</div>
          </div>
      </div>
      <div className="content">
        <div className="row">
          <div className="title">
            Shop:
          </div>
          <div className="input">
            <TextBtn
              type={"button"}
              text={"LuxinLux.com"}
              onclick={selectShop}
              loading={false}
              newType1={!(shop === "LuxinLux")}
            />
          </div>
        </div>
        <div className="row">
          <div className="title">
            Credit amount:
          </div>
          <div className="input">
            <TextInputWTitle
              name={"amount"}
              value={amount}
              error={""}
              onchange={onchange}
              title="Amount"
            />
            <div className="text">
              {formatPrice(Math.floor(amount/10))} toman
            </div>
          </div>
        </div>
        <div className="row">
          <div className="title">
            Type of Installments:
          </div>
          <div className="input" style={{width: "171px"}}>
            <SelectInputWTitle
              name={"installment"}
              title={'installment'}
              options={installmentOptions}
              value={installment}
              error={""}
              onchange={onchange}
            />
          </div>
        </div>
        <div className='full-width'>
          <div style={{ gridColumn: "7 / 9" }}>
            <TextBtn
              onclick={cancel}
              text={"Cancel"}
              type={""}
              newType1={true}
            />
          </div>
          <div style={{ gridColumn: "9 / 13" }}>
            <TextBtn
                text={"Send Request"}
                type={"submit"}
                onclick={sendData}
                loading={loading}
                disabled={!checkData() || loading}
            />
          </div>
        </div>
      </div>
    </StyleCss>
  )
}
export default WorkPageCreditEdit;


export const installmentOptions = [
  {
    value: 1,
    name: "One month",
  },
  {
    value: 2,
    name: "Two months",
  },
  {
    value: 4,
    name: "Four monts",
  },
  {
    value: 6,
    name: "Six months",
  },
];